import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function M() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();
    let lists: any = [
        {
            title: t('secM_list1_title'),
            desc: t('secM_list1_desc'),
        },
        {
            title: t('secM_list2_title'),
            desc: t('secM_list2_desc'),
        },
        {
            title: t('secM_list3_title'),
            desc: t('secM_list3_desc'),
        },
        {
            title: t('secM_list4_title'),
            desc: t('secM_list4_desc'),
        },
        {
            title: t('secM_list5_title'),
            desc: t('secM_list5_desc'),
        },
    ];
    if (['eu', 'uk'].includes(locale)) {
        lists = lists.slice(0, 2);
    }
    if (['it'].includes(locale)) {
        lists.pop();
    }
    if (['es'].includes(locale)) {
        lists = lists.slice(0, 3);
    }
    return (
        <div id="power-independence-M" className={`power-independence-M ${css['power-independence-M']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secM_title')}</p>
                </div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar, Navigation]}
                    navigation={true}
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapMnRelease: true,
                    }}
                >
                    {lists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            <div className="swiper-item-text">
                                <p className="card-desc">{card?.desc}</p>
                                <p className="card-title">{card?.title}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
